<div class="dialog">
    <div class="dialog-title">
        <h4>Delete Ticket <img src="assets/svg/close-white.svg" alt="close" (click)="close()"></h4>
    </div>
    <div class="content">
        <p>Are you sure you want to
        </p>
        <p> delete this ticket ?</p>
    </div>
    <div class="footer center">
        <button class="white" (click)="deleteTicket()">Yes, Delete</button>
        <button class="orange" (click)="close()">No, Keep</button>
    </div>

</div>
